import { isAfter } from 'date-fns';

/**
 * Transforms a reservation booking part fulfillments into a refundable for reservations.
 */
export function transformRefundableReservation(
    reservation: ApiSchema['Reservation'],
    apiBooking: ApiSchema['Booking'],
): RefundableReservation {
    const passengers = apiBooking.passengers
        .filter(p => reservation?.passengerIds.includes(p.id))
        .map(p => transformPassenger(p));
    const fulfillment = apiBooking.fulfillments?.find(f => f.issuer !== 'TOFT' && f.bookingParts?.some(bp => bp.id === reservation.id));
    const relatedApiTrip = apiBooking.trips?.find(t => reservation.tripCoverage?.coveredTripIds?.includes(t.id));
    const trip = relatedApiTrip ? transformBookedTrip(relatedApiTrip) : undefined;
    const id = reservation.id;
    const fulfillmentId = fulfillment?.id;
    const type = 'Reservation';
    const name = passengers.map(p => `${p.firstName} ${p.lastName}`).join(', ');
    const birthDate = passengers.map(p => `*${formatMonthMediumYear(p.dateOfBirth)}`).join(', ');
    const summaryLine1 = formatMonthMediumYear(trip?.departureTime);
    const summaryLine2 = '';
    const detailLine1 = `${name} ${birthDate}`;
    const detailLine2 = '';
    const status = reservation.status;
    const price = reservation.price;
    const refundConditionDate = reservation.afterSaleConditions?.find(c => c.condition === 'REFUND')?.validUntil;
    const refundDeadline = refundConditionDate ? zurichDate(refundConditionDate) : undefined;
    const isExpired = refundDeadline ? isAfter(zurichDate(), refundDeadline) : false;
    const isRefunded = status === 'REFUNDED';
    const isRefundable = !!refundDeadline && status === 'FULFILLED' && !isExpired;

    return {
        id,
        fulfillmentId,
        type,
        passengers,
        trip,
        summaryLine1,
        summaryLine2,
        detailLine1,
        detailLine2,
        status,
        price,
        refundDeadline,
        isExpired,
        isRefunded,
        isRefundable,
    };
}
